import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import ScrollToTop from "@/components/ScrollToTop";
import { CartProvider } from "@/context/CartContext";
import { registerServiceWorker } from "@/lib/sw-register";
import MainLayout from "@/components/MainLayout";
import Home from "@/pages/Home";
import Training from "@/pages/Training";
import CourseDetail from "@/pages/CourseDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CoursePlayer from "@/pages/CoursePlayer";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import FAQPage from "@/pages/FAQPage";
import ChangePassword from "@/pages/ChangePassword";
import Admin from "@/pages/Admin";
import Roster from "@/pages/Roster";
import Elearning from "@/pages/Elearning";
import ElearningDetail from "@/pages/ElearningDetail";
import Instructor from "@/pages/Instructor";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import LeadThanks from "@/pages/LeadThanks";

function App() {
  registerServiceWorker();
  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<MainLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Navigate to="/training" replace />} />
                <Route path="/training" element={<Training />} />
                <Route path="/training/:slug" element={<CourseDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/learn/:enrollmentId" element={<CoursePlayer />} />
                <Route path="/booking" element={<Navigate to="/training" replace />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/blog" element={<Navigate to="/resources" replace />} />
                <Route path="/blog/:slug" element={<Navigate to="/resources" replace />} />
                <Route path="/elearning" element={<Elearning />} />
                <Route path="/elearning/:slug" element={<ElearningDetail />} />
                <Route path="/instructor" element={<Instructor />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/refund" element={<Refund />} />
                <Route path="/lead-thanks" element={<LeadThanks />} />
                <Route path="/admin" element={<Admin />} />
              </Route>
              <Route path="/admin/roster/:sessionId" element={<Roster />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
